/**
 * Request the given module id version and return it as an object
 * @param {String} id
 * @return {Object}
 */
export function getGlobalVersion(id) {
  // Global object with set dependency versions
  const depVersions = window.depVersions || null;
  let globalVersion = null;

  // Object must have a hash and file name
  if (depVersions && depVersions[id] && depVersions[id].version && depVersions[id].main) {
    globalVersion = depVersions[id];
  }
  return globalVersion;
}
